import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
  Modal,
  InputGroup,
} from "react-bootstrap";
import {
  submitPendaftaran,
  getApiErrorMessage,
  checkNikPendamping,
  checkEmailPendamping,
  getProvinsi,
  getKabupaten,
  getKecamatan,
  getBanks,
} from "../../services/api";
import { useTheme } from "../../contexts/ThemeContext";
import "./PendaftaranP3H.css";

const PendaftaranP3H = () => {
  const { orgName } = useTheme();
  const [formData, setFormData] = useState({
    nama: "",
    alamat: "",
    provinsi: "",
    kabupaten: "",
    kecamatan: "",
    kelurahan: "",
    kode_pos: "",
    tempat_lahir: "",
    tgl_lahir: "",
    no_hp: "",
    email: "",
    nik: "",
    pendidikan: "",
    programstudi: "",
    universitas: "",
    pekerjaan: "",
    pekerjaan_lain: "",
    kode_bank: "",
    no_rekening: "",
    nama_rekening: "",
    alasan: "",
    referral: "",
  });

  const [fileKTP, setFileKTP] = useState(null);
  const [fileIjazah, setFileIjazah] = useState(null);
  const [fileFoto, setFileFoto] = useState(null);

  // Input mentah tanggal lahir (boleh dd/MM/yyyy atau MM/dd/yyyy).
  // Nilai ISO (yyyy-MM-dd) yang dipakai backend disimpan di formData.tgl_lahir.
  const [tglLahirInput, setTglLahirInput] = useState("");
  const [tglLahirError, setTglLahirError] = useState("");
  const tglPickerRef = useRef(null);

  const [provinsiList, setProvinsiList] = useState([]);
  const [kabupatenList, setKabupatenList] = useState([]);
  const [kecamatanList, setKecamatanList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [nikDuplikat, setNikDuplikat] = useState(null); // { nama, nama_lembaga }
  const [nikChecking, setNikChecking] = useState(false);
  const [emailDuplikat, setEmailDuplikat] = useState(false);
  const [copiedField, setCopiedField] = useState(null);
  const [registrationData, setRegistrationData] = useState({
    email: "",
    password: "",
    kode_referral: "",
  });

  useEffect(() => {
    fetchProvinsi();
    fetchBanks();
  }, []);

  const fetchProvinsi = async () => {
    try {
      const response = await getProvinsi();
      if (response.data.success) {
        setProvinsiList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching provinsi:", error);
    }
  };

  const fetchBanks = async () => {
    try {
      const response = await getBanks();
      if (response.data.success) {
        setBankList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };

  const handleProvinsiChange = async (e) => {
    const kodeprovinsi = e.target.value;
    setFormData({
      ...formData,
      provinsi: kodeprovinsi,
      kabupaten: "",
      kecamatan: "",
    });
    setKabupatenList([]);
    setKecamatanList([]);

    if (kodeprovinsi) {
      try {
        const response = await getKabupaten(kodeprovinsi);
        if (response.data.success) {
          setKabupatenList(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching kabupaten:", error);
      }
    }
  };

  const handleKabupatenChange = async (e) => {
    const kodekabupaten = e.target.value;
    setFormData({ ...formData, kabupaten: kodekabupaten, kecamatan: "" });
    setKecamatanList([]);

    if (kodekabupaten) {
      try {
        const response = await getKecamatan(kodekabupaten);
        if (response.data.success) {
          setKecamatanList(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching kecamatan:", error);
      }
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Reset status duplikat jika NIK diubah
    if (e.target.name === "nik") setNikDuplikat(null);
  };

  // Parse tanggal yang diketik bebas (dd/MM/yyyy atau MM/dd/yyyy) menjadi ISO
  // yyyy-MM-dd. Pemisah boleh "/", "-", atau ".". Mengembalikan null bila tidak
  // dapat dikenali sebagai tanggal yang valid.
  const parseFlexibleDate = (raw) => {
    if (!raw) return null;
    const parts = raw
      .trim()
      .split(/[/\-.]/)
      .map((p) => p.trim())
      .filter((p) => p !== "");
    if (parts.length !== 3 || parts.some((p) => !/^\d+$/.test(p))) return null;

    let day, month, year;
    if (parts[0].length === 4) {
      // Format diawali tahun: yyyy/MM/dd
      year = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10);
      day = parseInt(parts[2], 10);
    } else {
      const a = parseInt(parts[0], 10);
      const b = parseInt(parts[1], 10);
      year = parseInt(parts[2], 10);
      if (parts[2].length < 4) {
        year = year < 100 ? (year >= 30 ? 1900 + year : 2000 + year) : year;
      }
      if (a > 12 && b <= 12) {
        // Pasti dd/MM/yyyy
        day = a;
        month = b;
      } else if (b > 12 && a <= 12) {
        // Pasti MM/dd/yyyy
        month = a;
        day = b;
      } else {
        // Ambigu (keduanya <= 12) -> default dd/MM/yyyy (konvensi Indonesia)
        day = a;
        month = b;
      }
    }

    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    const date = new Date(year, month - 1, day);
    // Pastikan tanggal benar-benar valid (mis. 31/02 ditolak)
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    const mm = String(month).padStart(2, "0");
    const dd = String(day).padStart(2, "0");
    return `${year}-${mm}-${dd}`;
  };

  const handleTglLahirChange = (e) => {
    const raw = e.target.value;
    setTglLahirInput(raw);
    const iso = parseFlexibleDate(raw);
    setFormData((prev) => ({ ...prev, tgl_lahir: iso || "" }));
    if (!raw.trim()) {
      setTglLahirError("");
    } else if (!iso) {
      setTglLahirError("Format tanggal belum lengkap/valid (cth: 08/21/1990).");
    } else {
      setTglLahirError("");
    }
  };

  // Membuka native date picker dari tombol ikon kalender.
  const openDatePicker = () => {
    const el = tglPickerRef.current;
    if (!el) return;
    if (typeof el.showPicker === "function") {
      try {
        el.showPicker();
        return;
      } catch (err) {
        // fallback ke klik biasa jika showPicker gagal
      }
    }
    el.focus();
    el.click();
  };

  // Saat user memilih dari date picker (nilai native ISO yyyy-MM-dd),
  // sinkronkan ke input teks dalam tampilan dd/MM/yyyy.
  const handleTglLahirPick = (e) => {
    const iso = e.target.value; // "yyyy-MM-dd" atau ""
    setFormData((prev) => ({ ...prev, tgl_lahir: iso }));
    if (iso) {
      const [y, m, d] = iso.split("-");
      setTglLahirInput(`${d}/${m}/${y}`);
    } else {
      setTglLahirInput("");
    }
    setTglLahirError("");
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  const handleNikBlur = async (e) => {
    const nik = e.target.value.trim();
    if (nik.length !== 16) return;
    setNikChecking(true);
    try {
      const res = await checkNikPendamping(nik);
      if (!res.data.available) {
        setNikDuplikat({ nama: res.data.nama, nama_lembaga: res.data.nama_lembaga });
      } else {
        setNikDuplikat(null);
      }
    } catch (err) {
      console.error("checkNik error:", err);
    } finally {
      setNikChecking(false);
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      if (type === "ktp") {
        setFileKTP(file);
      } else if (type === "ijazah") {
        setFileIjazah(file);
      } else if (type === "foto") {
        setFileFoto(file);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, type: "", message: "" });

    // Validasi tanggal lahir: harus terisi dan dapat di-parse menjadi tanggal valid
    if (!formData.tgl_lahir) {
      setTglLahirError(
        tglLahirInput.trim()
          ? "Tanggal lahir tidak valid. Gunakan format dd/MM/yyyy atau MM/dd/yyyy."
          : "Tanggal lahir wajib diisi.",
      );
      setAlert({
        show: true,
        type: "danger",
        message: "Tanggal lahir tidak valid. Mohon periksa kembali.",
      });
      setLoading(false);
      return;
    }

    try {
      const formDataToSubmit = new FormData();

      // Cek NIK — baik sudah dicek sebelumnya maupun belum
      let duplikat = nikDuplikat;
      if (!duplikat && formData.nik.trim().length === 16) {
        try {
          const res = await checkNikPendamping(formData.nik.trim());
          if (!res.data.available) {
            duplikat = { nama: res.data.nama, nama_lembaga: res.data.nama_lembaga };
            setNikDuplikat(duplikat);
          }
        } catch (err) {
          console.error("NIK check on submit error:", err);
        }
      }
      if (duplikat) {
        setAlert({
          show: true,
          type: "danger",
          message: `NIK sudah digunakan oleh: ${duplikat.nama} (LP3H: ${duplikat.nama_lembaga}). Pendaftaran tidak dapat dilanjutkan.`,
        });
        setLoading(false);
        return;
      }

      // Cek email di SIHALAL
      if (formData.email.trim()) {
        try {
          const emailRes = await checkEmailPendamping(formData.email.trim());
          if (emailRes.data.available === false) {
            setEmailDuplikat(true);
            setLoading(false);
            return;
          }
        } catch (emailErr) {
          console.error("Email check on submit error:", emailErr);
        }
      }

      // Append all form fields
      Object.keys(formData).forEach((key) => {
        formDataToSubmit.append(key, formData[key]);
      });

      // Append files (field text formData sudah termasuk nik — dipakai untuk nama file foto)
      if (fileFoto) {
        formDataToSubmit.append("filefoto", fileFoto);
      }
      if (fileKTP) {
        formDataToSubmit.append("fotoktp", fileKTP);
      }
      if (fileIjazah) {
        formDataToSubmit.append("fotoijazah", fileIjazah);
      }

      const response = await submitPendaftaran(formDataToSubmit);
      if (!response.data.success) {
        setAlert({
          show: true,
          type: "danger",
          message:
            response.data.message ||
            "Pendaftaran gagal dikirim. Silakan periksa data Anda.",
        });
        return;
      }

      // Set data untuk modal
      setRegistrationData({
        email: formData.email,
        password: formData.no_hp,
        kode_referral: response.data.kode_referral,
      });

      setShowSuccessModal(true);

      setFormData({
        nama: "",
        alamat: "",
        provinsi: "",
        kabupaten: "",
        kecamatan: "",
        kelurahan: "",
        kode_pos: "",
        tempat_lahir: "",
        tgl_lahir: "",
        no_hp: "",
        email: "",
        nik: "",
        pendidikan: "",
        programstudi: "",
        universitas: "",
        pekerjaan: "",
        pekerjaan_lain: "",
        kode_bank: "",
        no_rekening: "",
        nama_rekening: "",
        alasan: "",
        referral: "",
      });
      setTglLahirInput("");
      setTglLahirError("");
      setFileKTP(null);
      setFileIjazah(null);
      setFileFoto(null);
      setKabupatenList([]);
      setKecamatanList([]);
    } catch (error) {
      console.error("Submit pendaftaran error:", error.response?.data || error);
      setAlert({
        show: true,
        type: "danger",
        message: getApiErrorMessage(
          error,
          "Terjadi kesalahan saat mengirim pendaftaran. Silakan coba lagi.",
        ),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <Container>
          <h1>Pendaftaran P3H</h1>
          <p className="lead text-white mt-3">
            Dapatkan Penghasilan Jutaan Rupiah Setiap Bulan Dengan Menjadi
            Pendamping Proses Produk Halal (P3H) Dengan 1 juta lebih kuota
            penerbitan sertifikat halal self declare gratis oleh Badan
            Penyelenggara Jaminan Produk Halal (BPJPH) maka peluang Anda
            mendapatkan penghasilan tambahan sebagai P3H cukup besar.
            Bergabunglah dengan {orgName} sekarang juga.
          </p>
        </Container>
      </div>

      <Container className="content-section">
        {alert.show && (
          <Alert
            variant={alert.type}
            onClose={() => setAlert({ ...alert, show: false })}
            dismissible
          >
            {alert.message}
          </Alert>
        )}

        <Card className="shadow">
          <Card.Body className="p-4">
            <Form onSubmit={handleSubmit}>
              {/* Data Pribadi */}
              <h4 className="mb-4 text-primary">Data Pribadi</h4>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Nama Lengkap <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="nama"
                      value={formData.nama}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      NIK <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="nik"
                      maxLength="16"
                      value={formData.nik}
                      onChange={handleChange}
                      onBlur={handleNikBlur}
                      isInvalid={!!nikDuplikat}
                      required
                    />
                    {nikChecking && (
                      <Form.Text className="text-muted">Memeriksa NIK...</Form.Text>
                    )}
                    {nikDuplikat && (
                      <Form.Control.Feedback type="invalid">
                        NIK sudah digunakan.
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Tempat Lahir <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="tempat_lahir"
                      value={formData.tempat_lahir}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Tanggal Lahir <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup hasValidation className="position-relative">
                      <Form.Control
                        type="text"
                        name="tgl_lahir_input"
                        placeholder="MM/dd/yyyy"
                        value={tglLahirInput}
                        onChange={handleTglLahirChange}
                        isInvalid={!!tglLahirError}
                        inputMode="numeric"
                        autoComplete="off"
                        required
                      />
                      <Button
                        variant="outline-secondary"
                        type="button"
                        onClick={openDatePicker}
                        aria-label="Pilih tanggal dari kalender"
                        title="Pilih tanggal dari kalender"
                      >
                        <i className="fas fa-calendar-alt" />
                      </Button>
                      <input
                        ref={tglPickerRef}
                        type="date"
                        tabIndex={-1}
                        aria-hidden="true"
                        value={formData.tgl_lahir}
                        onChange={handleTglLahirPick}
                        className="tgl-lahir-hidden-date"
                      />
                      <Form.Control.Feedback type="invalid">
                        {tglLahirError}
                      </Form.Control.Feedback>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      Ketik MM/dd/yyyy (bulan/tanggal/tahun), atau pilih dari kalender.
                      {formData.tgl_lahir && (
                        <> Terbaca: <strong>{formData.tgl_lahir}</strong></>
                      )}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      No. HP <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      name="no_hp"
                      value={formData.no_hp}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Alamat */}
              <h4 className="mb-4 mt-4 text-primary">Alamat</h4>
              <Form.Group className="mb-3">
                <Form.Label>
                  Alamat Lengkap <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="alamat"
                  value={formData.alamat}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Provinsi <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="provinsi"
                      value={formData.provinsi}
                      onChange={handleProvinsiChange}
                      required
                    >
                      <option value="">Pilih Provinsi</option>
                      {provinsiList.map((prov) => (
                        <option
                          key={prov.kodeprovinsi}
                          value={prov.kodeprovinsi}
                        >
                          {prov.namaprovinsi}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Kabupaten/Kota <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="kabupaten"
                      value={formData.kabupaten}
                      onChange={handleKabupatenChange}
                      required
                      disabled={!formData.provinsi}
                    >
                      <option value="">Pilih Kabupaten/Kota</option>
                      {kabupatenList.map((kab) => (
                        <option
                          key={kab.kodekabupaten}
                          value={kab.kodekabupaten}
                        >
                          {kab.namakabupaten}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Kecamatan <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="kecamatan"
                      value={formData.kecamatan}
                      onChange={handleChange}
                      required
                      disabled={!formData.kabupaten}
                    >
                      <option value="">Pilih Kecamatan</option>
                      {kecamatanList.map((kec) => (
                        <option
                          key={kec.kodekecamatan}
                          value={kec.kodekecamatan}
                        >
                          {kec.namakecamatan}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Kelurahan <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="kelurahan"
                      value={formData.kelurahan}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Kode Pos</Form.Label>
                    <Form.Control
                      type="text"
                      name="kode_pos"
                      maxLength="5"
                      value={formData.kode_pos}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Pendidikan */}
              <h4 className="mb-4 mt-4 text-primary">Pendidikan</h4>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Pendidikan Terakhir <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="pendidikan"
                      value={formData.pendidikan}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Pendidikan</option>
                      <option value="SMA">SMA/Sederajat</option>
                      <option value="D3">D3</option>
                      <option value="S1">S1</option>
                      <option value="S2">S2</option>
                      <option value="S3">S3</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Program Studi <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="programstudi"
                      value={formData.programstudi}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Universitas/Institusi{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="universitas"
                      value={formData.universitas}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Pekerjaan */}
              <h4 className="mb-4 mt-4 text-primary">Pekerjaan</h4>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Pekerjaan <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="pekerjaan"
                      value={formData.pekerjaan}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Pekerjaan</option>
                      <option value="PNS">PNS</option>
                      <option value="Swasta">Swasta</option>
                      <option value="Wiraswasta">Wiraswasta</option>
                      <option value="Lainnya">Lainnya</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Pekerjaan Lainnya (jika memilih Lainnya)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pekerjaan_lain"
                      value={formData.pekerjaan_lain}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Data Rekening */}
              <h4 className="mb-4 mt-4 text-primary">Data Rekening Bank</h4>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Bank <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="kode_bank"
                      value={formData.kode_bank}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Bank</option>
                      {bankList.map((bank) => (
                        <option key={bank.code} value={bank.code}>
                          {bank.bank_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Nomor Rekening <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="no_rekening"
                      value={formData.no_rekening}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Nama Pemilik Rekening{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="nama_rekening"
                      value={formData.nama_rekening}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Upload Dokumen */}
              <h4 className="mb-4 mt-4 text-primary">Upload Dokumen</h4>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Foto Diri (Opsional)</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/jpeg,image/png,image/jpg"
                      onChange={(e) => handleFileChange(e, "foto")}
                    />
                    <Form.Text className="text-muted">
                      Foto berwarna terbaru (JPG/PNG, max 5MB). Bisa juga
                      diunggah nanti lewat menu Profil setelah login.
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Foto KTP <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "ktp")}
                      required
                    />
                    <Form.Text className="text-muted">
                      Upload foto KTP (format: JPG, PNG, max 5MB)
                    </Form.Text>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Foto Ijazah <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "ijazah")}
                      required
                    />
                    <Form.Text className="text-muted">
                      Upload foto ijazah terakhir (format: JPG, PNG, max 5MB)
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              {/* Informasi Tambahan */}
              <h4 className="mb-4 mt-4 text-primary">Informasi Tambahan</h4>
              <Form.Group className="mb-3">
                <Form.Label>
                  Alasan Ingin Menjadi P3H{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="alasan"
                  value={formData.alasan}
                  onChange={handleChange}
                  placeholder="Jelaskan alasan Anda ingin menjadi Pendamping Proses Produk Halal"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Kode Referral (Opsional)</Form.Label>
                <Form.Control
                  type="text"
                  name="referral"
                  value={formData.referral}
                  onChange={handleChange}
                  placeholder="Masukkan kode referral jika ada"
                />
                <Form.Text className="text-muted">
                  Jika Anda direferensikan oleh P3H lain, masukkan kode
                  referralnya
                </Form.Text>
              </Form.Group>

              <div className="d-grid gap-2 mt-4">
                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  disabled={loading}
                >
                  {loading ? "Mengirim..." : "Kirim Pendaftaran"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* Email Duplikat Modal */}
        <Modal show={emailDuplikat} onHide={() => setEmailDuplikat(false)} centered>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title>
              <i className="fas fa-exclamation-circle me-2"></i>
              Email Sudah Digunakan
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Email <strong>{formData.email}</strong> sudah terdaftar di sistem.
            </p>
            <p className="mb-0">
              Silakan gunakan email lain untuk mendaftar.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setEmailDuplikat(false)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        {/* NIK Duplikat Modal */}
        <Modal show={!!nikDuplikat} onHide={() => setNikDuplikat(null)} centered>
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title>
              <i className="fas fa-exclamation-triangle me-2"></i>
              NIK Sudah Terdaftar
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              NIK sudah digunakan oleh:{" "}
              <strong>{nikDuplikat?.nama}</strong>
            </p>
            <p>
              Nama LP3H: <strong>{nikDuplikat?.nama_lembaga}</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setNikDuplikat(null)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Success Modal */}
        <Modal
          show={showSuccessModal}
          onHide={() => setShowSuccessModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <i className="fas fa-check-circle me-2"></i>
              Pendaftaran Berhasil!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="text-center mb-4">
              <i
                className="fas fa-check-circle text-success"
                style={{ fontSize: "4rem" }}
              ></i>
            </div>
            <h5 className="text-center mb-4">
              Terima kasih telah mendaftar sebagai Calon Pendamping P3H!
            </h5>

            <Alert variant="info" className="mb-4">
              <Alert.Heading className="h6">
                <i className="fas fa-info-circle me-2"></i>
                Kode Referral Anda
              </Alert.Heading>
              <div className="text-center">
                <h3 className="mb-0 font-monospace">
                  {registrationData.kode_referral}
                </h3>
              </div>
              <hr />
              <p className="mb-0 small">
                Simpan kode referral ini untuk mendapatkan benefit tambahan
              </p>
            </Alert>

            <Alert variant="primary">
              <Alert.Heading className="h6">
                <i className="fas fa-key me-2"></i>
                Informasi Login Anda
              </Alert.Heading>
              <div className="mt-3">
                <Row className="mb-2">
                  <Col xs={4} className="fw-bold">
                    Email/Username:
                  </Col>
                  <Col xs={8}>
                    <div className="d-flex align-items-center gap-2">
                      <code className="bg-light px-2 py-1 rounded flex-grow-1 text-break">
                        {registrationData.email}
                      </code>
                      <Button
                        variant={copiedField === "email" ? "success" : "outline-secondary"}
                        size="sm"
                        className="flex-shrink-0"
                        onClick={() => copyToClipboard(registrationData.email, "email")}
                        title="Salin email"
                      >
                        <i className={`fas fa-${copiedField === "email" ? "check" : "copy"}`}></i>
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} className="fw-bold">
                    Password:
                  </Col>
                  <Col xs={8}>
                    <div className="d-flex align-items-center gap-2">
                      <code className="bg-light px-2 py-1 rounded flex-grow-1 text-break">
                        {registrationData.password}
                      </code>
                      <Button
                        variant={copiedField === "password" ? "success" : "outline-secondary"}
                        size="sm"
                        className="flex-shrink-0"
                        onClick={() => copyToClipboard(registrationData.password, "password")}
                        title="Salin password"
                      >
                        <i className={`fas fa-${copiedField === "password" ? "check" : "copy"}`}></i>
                      </Button>
                    </div>
                    <small className="d-block text-muted mt-1">
                      (Password menggunakan nomor HP Anda)
                    </small>
                  </Col>
                </Row>
              </div>
              <hr />
              <p className="mb-0 small text-muted">
                <i className="fas fa-exclamation-triangle me-1"></i>
                Harap simpan informasi login ini dengan baik. Anda dapat login
                ke aplikasi menggunakan email dan password di atas.
              </p>
            </Alert>

            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="mb-2">
                <i className="fas fa-clipboard-list me-2"></i>
                Langkah Selanjutnya:
              </h6>
              <ol className="mb-0 ps-3">
                <li>Data Anda akan diverifikasi oleh admin</li>
                <li>Anda akan menerima notifikasi melalui email</li>
                <li>
                  Anda sudah dapat login dengan kredensial di atas untuk melihat
                  status pendaftaran
                </li>
              </ol>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowSuccessModal(false)}
            >
              Tutup
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setShowSuccessModal(false);
                window.location.href = "/admin/login";
              }}
            >
              <i className="fas fa-sign-in-alt me-2"></i>
              Login Sekarang
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default PendaftaranP3H;
